import React, { Component } from "react";
import axios from "axios";
// import { Link } from "react-router-dom";
import swal from 'sweetalert';
import $ from "jquery";
import NumberFormat from 'react-number-format';


import Header from "./common/Header";
import Sidebar from "./common/Sidebar";
import { Link } from "react-router-dom";

export class Landvest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homes: [],
      currentPage: 1,
      homesPerPage: 9,
      query: "",
      isLoading: true,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  queryField = (e) => {
    e.preventDefault();
    this.setState({
      query: e.target.value,
    });
    axios
      .get(`${axios.defaults.baseURL}/search-lands/${this.state.query}`)
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({ homes: json.data.homes });
        } else alert("Fetching Homes Failed!");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  };

  handleClick(event) {
    event.preventDefault();
    this.setState({
      currentPage: Number(event.target.id),
    });
  }

  componentDidMount() {
    this.fetchHomes();
  }

  fetchHomes = (e) => {
    axios
      .get(`${axios.defaults.baseURL}/lands`)
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({ homes: json.data.homes, isLoading: false });
        } else alert("Fetching Homes Failed!");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  };

  render() {
    const { homes, currentPage, homesPerPage, isLoading } = this.state;

    // Logic for displaying homes
    const homesList = this.state.homes;
    const indexOfLastHome = currentPage * homesPerPage;
    const indexOfFirstHome = indexOfLastHome - homesPerPage;
    const currentHomes = homesList.slice(indexOfFirstHome, indexOfLastHome);

    const renderHomes = currentHomes.map((home, index) => {
      return (
        <div
          className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2"
          key={home.id}
        >
          <div className="wrap dash-card-main bg-white position-relative">
            <div className="wrap px-2 position-absolute w-100">
              <div className="dash-card-main thumb bg-dark mt-2 shadow-xl bg-cover">
              <Link to={{pathname: `view-land/${home.name}`}}>
                <img
                  src={home.image}
                  className="plan-img"
                  alt=""
                />
                </Link>
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="wrap p-4 pt-5">
              <div className="row mt-1 mb-2 pt-5">
                <div className="pt-2 col">
      <h6 className="text-primary mb-0 titlecase">{home.name} @ <NumberFormat value={home.price} displayType={'text'} thousandSeparator={true} prefix={'₦'} /> {home.type}</h6>
      <span className="badge text-light badge-primary">Duration: {home.duration} {
        home.type == "monthly" ? ('Months') : home.type == "weekly" ? ('Weeks') : null
      }</span>
                </div>
              </div>
            </div>
            <hr className="mt-0"></hr>
            <div className="wrap px-4 pb-4">
              <div className="row no-gutters">
                <div className="col">
                  { home.status == "active" ? (
                        <Link to={{pathname: `view-land/${home.name}`}} className="btn w-100 btn-primary">
                        View
                      </Link>
                    ) : home.status == "soldout"  ? (<input type="button" className="btn w-100 btn-warning" value="Sold Out" disabled/>) : null
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(homes.length / homesPerPage); i++) {
      pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map((number) => {
      return (
        <>
        { number == currentPage ? (
        <li
          className="pg-link active-link"
          key={number}
          id={number}
          onClick={this.handleClick}
        >
          {number}
        </li> 
        ) :
        <li
          className="pg-link"
          key={number}
          id={number}
          onClick={this.handleClick}
        >
          {number}
        </li> 
      }
      </>
      );
    });

    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div className="page-title">
                    <div className="row text-primary py-2 pt-4">
                      <div className="col-10">
                        <div
                          className="user-welcome"
                          style={{ overflow: "hidden" }}
                        >
                          <div className="wrapper d-flex">
                            <h4 className="d-inline-block">Landvest</h4>
                          </div>
                          <p className="text-secondary">
                            Available Lands Listing
                          </p>
                        </div>
                      </div>
                      <div className="text-right col-2"></div>
                    </div>
                  </div>
                  <div className="row mt-4 align-items-stretch">
                    {/* Product Listing */}
                    {isLoading ? (
                      <>
                        <div className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2">
                          <div className="wrap dash-card-main bg-white position-relative">
                            <div className="wrap px-2 position-absolute w-100">
                              <div className="dash-card-main mt-2 bg-cover blink_me">
                                Loading...
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2">
                          <div className="wrap dash-card-main bg-white position-relative">
                            <div className="wrap px-2 position-absolute w-100">
                              <div className="dash-card-main mt-2 bg-cover blink_me">
                                Loading...
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2">
                          <div className="wrap dash-card-main bg-white position-relative">
                            <div className="wrap px-2 position-absolute w-100">
                              <div className="dash-card-main mt-2 bg-cover blink_me">
                                Loading...
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>{renderHomes}</>
                    )}
                    {/* End Product Listing */}
                  </div>
                </div>
                  <div className="text-center">
                    {renderPageNumbers}
                  </div><br/><br/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Landvest;
